<template>
  <svg t="1611633582917" class="icon" fill="currentColor" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
       p-id="10206" width="200" height="200">
    <path
        d="M896 64c38.4 0 64 25.6 64 64v768c0 38.4-25.6 64-64 64H128c-38.4 0-64-25.6-64-64V128c0-38.4 25.6-64 64-64h768zM128 0C57.6 0 0 57.6 0 128v768c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128V128c0-70.4-57.6-128-128-128H128z"
        p-id="10207"></path>
    <path
        d="M364.8 812.8c-38.4 0-76.8-12.8-102.4-44.8-57.6-57.6-57.6-153.6 0-217.6l76.8-76.8 51.2 51.2-76.8 76.8c-32 32-32 76.8 0 102.4 32 32 76.8 32 102.4 0l102.4-102.4c12.8-12.8 25.6-32 25.6-51.2 0-19.2-6.4-38.4-19.2-51.2l-38.4-38.4 51.2-51.2 44.8 38.4c25.6 25.6 44.8 64 44.8 102.4s-19.2 83.2-51.2 108.8l-102.4 102.4c-32 32-70.4 51.2-108.8 51.2z"
        p-id="10208"></path>
    <path
        d="M486.4 614.4l-44.8-32c-57.6-64-57.6-160 0-217.6l102.4-102.4c57.6-57.6 153.6-57.6 217.6 0s57.6 153.6 0 217.6l-76.8 76.8-51.2-57.6 76.8-76.8c32-32 32-76.8 0-102.4-32-32-76.8-32-102.4 0L499.2 416c-32 32-32 76.8 0 108.8l44.8 44.8-57.6 44.8z"
        p-id="10209"></path>
  </svg>
</template>
<script>
    export default {
        name: 'icon-link'
    }
</script>
